module.exports = __webpack_public_path__ + "static/media/casa.8b16f3da.svg";